export default __webpack_public_path__ + "_/images/app/ios/ios-en-3-b041c1999fee8a1dc963bf0117b677cc08e1bca8bd7177e1a201db5345762f62.jpg";